import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import { UserContext } from '../context/UserContext';
import CommonLayout from '../components/CommonLayout';
import API from '../config/axiosConfig';
import './Welcome.scss';

// Welcome video on YouTube. youtube-nocookie keeps the player from setting
// tracking cookies until the user presses play. No `hl=he`: a Hebrew player UI
// switches on YouTube's auto-generated captions on top of the burned-in ones.
const WELCOME_VIDEO_ID = 'pHBOGaeNJ_A';
const WELCOME_VIDEO_SRC = `https://www.youtube-nocookie.com/embed/${WELCOME_VIDEO_ID}?rel=0&playsinline=1`;

const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});

const theme = createTheme({ typography: { fontFamily: '"Rubik", sans-serif' },
  direction: 'rtl',
});

function Welcome() {
  const { user } = useContext(UserContext);

  
  const pendingRequests = user?.pendingRequests || [];
  const isAdmin = user?.isSuperAdmin || user?.roles?.some(role => role.role === 'ADMIN');

  return (
    <CommonLayout>
      <div className="welcome-container" style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
        <CacheProvider value={cacheRtl}>
          <ThemeProvider theme={theme}>
            <div className="welcome-content" style={{ backgroundColor: 'white', padding: '24px', borderRadius: '8px', direction: 'rtl' }}>
              <h1 style={{ color: '#1FB5A3', marginBottom: '24px' }}>
                ברוכים הבאים ל mashlom.me !
              </h1>

              <p>
                אנחנו שמחים שבחרת להשתמש בפלטפורמה שלנו. נעשה הכל כדי שהמערכת תתאים לצרכיך ותאפשר לך לתת לנו רפואה טובה יותר.
              </p>
              {pendingRequests.length > 0 && (
                <div className="pending-request-section" style={{ marginTop: '20px', padding: '15px', border: '1px solid #ddd', borderRadius: '5px', 
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}>
                  <p>
                    כרגע, הבקשה שלך להצטרף למחלקת {pendingRequests.map(pr => pr.department?.nameHebrew).join(', ')} ממתינה לאישור המנהל\ת. מרגע קבלת האישור ניתן יהיה לצפות בפרוטוקולים של המחלקה, לתעד מקרים רפואיים ולהשתמש באפליקציות שלנו.                    
                  </p>
                </div>
              )}

              {isAdmin && (
                <div className="admin-section" style={{ marginTop: '20px', padding: '15px', borderRadius: '5px' }}>
                  <h3 >איך זה עובד?</h3>
                  <p>
בתפריט הניווט ניתן להיכנס לדף הפרוטוקולים ולרכז שם את כל פרוטוקולי הטיפול הרלוונטים לעבודתך השוטפת.
בדף מקרים רפואיים, ניתן לתעד מקרים שהגיעו למחלקה, לצורך למידה וזיהוי מהיר גם במקרים עתידיים.
</p>
                  <p>
                    בדף האפליקציות ניתן להוסיף אפליקציות ומחשבונים כך שיסייעו לכלל המשתמשים במחלקה.
                  </p>
                                    <p>
                    בדף המשתמשים  ניתן להוסיף או להסיר משתמשים מהמחלקה. כל משתמש יכול להיות מוגדר כ"משתמש" - צופה בלבד, "עורך" - עורך תוכן, או "אדמין" -שיכול לנהל, להוסיף או להסיר משתמשים.
                  </p>

                </div>
              )}

              <p style={{ marginTop: '20px' }}>
                אנו ממליצים לשנות את הסיסמה מעת לעת ב<Link to="/profile" style={{ color: '#1FB5A3' }}>דף הפרופיל</Link>. אין להתייחס לזה כדבר של מה בכך - שמירה על אבטחת מידע חשובה מאוד. חשובה לנו, וצריכה להיות חשובה גם לך.                
              </p>              
              <div style={{ margin: '24px 0' }}>
                <iframe
                  src={WELCOME_VIDEO_SRC}
                  title="סרטון: ברוכים הבאים ל־mashlom.me"
                  loading="lazy"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                  style={{
                    display: 'block',
                    width: '100%',
                    aspectRatio: '16 / 9',
                    border: 0,
                    borderRadius: '8px',
                    boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
                  }}
                />
              </div>
              <p>
                מזהה עוד צרכים שנוכל לעזור בהם? אנחנו כאן בשבילך! ניתן ליצור איתנו קשר בכתובת <a href="mailto:mashlom.me@gmail.com" style={{color: 'rgb(31, 181, 163)'}}>mashlom.me@gmail.com</a>
              </p>
              <p style={{  fontWeight: 'bold' }}>
                צוות mashlom.me
              </p>
            </div>
          </ThemeProvider>
        </CacheProvider>
      </div>
    </CommonLayout>
  );
}

export default Welcome;
